import type { IntlShape } from 'react-intl';

import { messages } from '@/messages/boutique';

export const getStoreLabelMap = (
  formatMessage: IntlShape['formatMessage'],
): Record<string, string> => {
  return {
    OFFICIAL_RETAILER: formatMessage(messages.retailer),
    BOUTIQUE: formatMessage(messages.boutique),
    FLAG_SHIP_BOUTIQUE: formatMessage(messages.flagshipBoutique),
    OUTLETS: formatMessage(messages.outlets),
    SERVICE_CENTER: formatMessage(messages.serviceCenter),
  };
};
